import { Fragment, useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import styled from "styled-components";

import Main from "./components/Main";
import Message from "./components/Message";
import Registration from "./components/Registration";
import Programs from "./components/Programs";
import Map from "./components/Map";
import Navigation from "./components/Navigation";

const ScrollToTop = (props) => {
	const location = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	return <Fragment>{props.children}</Fragment>;
};

const AppContainer = styled.div`
	width: 100vw;
	max-width: 600px;
	height: 100vh;
	margin: 0;
	box-sizing: border-box;
`;

function App() {
	const urlInfo = window.location.href.split("/");
	const buttonList = [
		["메인", ""],
		["인사말", "message"],
		["프로그램", "program"],
		["참가등록", "registration"],
		["오시는 길", "map"],
	];
	const [active, setActive] = useState(urlInfo[urlInfo.length - 1]);
	const handleClick = (button) => {
		setActive(button);
	};

	return (
		<AppContainer>
			<ScrollToTop>
				<Routes>
					<Route element={<Main />} path='/' exact />
					<Route element={<Message />} path='/message' exact />
					<Route element={<Registration />} path='/registration' exact />
					<Route element={<Programs />} path='/program' exact />
					<Route element={<Map />} path='/map' exact />
				</Routes>
			</ScrollToTop>
			<Navigation
				buttonList={buttonList}
				active={active}
				handleClick={handleClick}
			/>
		</AppContainer>
	);
}

export default App;
